import { render, staticRenderFns } from "./MobileVideoBox.vue?vue&type=template&id=4f99a120&scoped=true&"
import script from "./MobileVideoBox.vue?vue&type=script&lang=js&"
export * from "./MobileVideoBox.vue?vue&type=script&lang=js&"
import style0 from "./MobileVideoBox.vue?vue&type=style&index=0&id=4f99a120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99a120",
  null
  
)

export default component.exports